export default __webpack_public_path__ + "static/sparx_systems-6cf36974dde161ea33fc9a3e6daabca0.png";